import React from 'react';
// import PropTypes from 'prop-types';

import {Routes, Route} from 'react-router-dom';

import Welcome from './welcome/Welcome';
import SignOut from './auth/Signout';

const Router = () => {
  return (
    <Routes>
      <Route path="/" element={<Welcome />} />


      <Route path="/welcome" element={<Welcome />} />

      <Route path="/signout" element={<SignOut />} />

    </Routes>
  );
};

Router.propTypes = {
};

export default React.memo(Router);

